import React from 'react';

import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';

interface IProps {
    children: React.ReactNode,
}
/**
 * Враппер для элементов формы оплаты
 * Позволяет раположить элементы согласно дизайну
 */
export const PaymentFieldWrapper = ({ children }: IProps): JSX.Element => {
    return (
        <FullWidthListContainer $direction='column' $size={24} style={{ maxWidth: '800px' }}>
            {children}
        </FullWidthListContainer>
    );
};
